/**
 * Labstep
 *
 * @module prosemirror/components/NodeView/Metadata
 * @desc Renders a Metadata node
 */

import {
  type Metadata,
  Metadata as MetadataModel,
} from 'labstep-web/models/metadata';
import type { Protocol } from 'labstep-web/models/protocol.model';
import { MetadataBlockComponent } from 'labstep-web/prosemirror/components/NodeView/Metadata/Block';
import { Read } from 'labstep-web/prosemirror/components/NodeView/Read';
import { useReactNodeView } from 'labstep-web/prosemirror/components/ReactNodeView';
import React from 'react';
import type {
  MetadataNodeProps,
  MetadataNodeViewProps,
} from './types';

export class MetadataNode extends React.Component<MetadataNodeProps> {
  public shouldComponentUpdate(): boolean {
    return Boolean(!this);
  }

  public render(): React.ReactElement {
    const { id, entity, timestamp } = this.props;
    return (
      <div contentEditable={false}>
        <Read
          entityName={entity.entityName}
          id={entity.id}
          timestamp={timestamp}
        >
          {({ entity: protocol }): React.ReactElement => (
            <Read
              entityName={MetadataModel.entityName}
              id={id}
              timestamp={timestamp}
            >
              {({ entity: metadata }): React.ReactElement => (
                <MetadataBlockComponent
                  entity={protocol as Protocol}
                  metadata={metadata as Metadata}
                  readOnly={!!timestamp}
                />
              )}
            </Read>
          )}
        </Read>
      </div>
    );
  }
}

export const MetadataNodeView: React.FC<MetadataNodeViewProps> = ({
  entity,
  timestamp,
}) => {
  const context = useReactNodeView();
  const { id } = (context.node as any).attrs;

  return (
    <MetadataNode entity={entity} id={id} timestamp={timestamp} />
  );
};
